(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Environment_tr', Environment_tr);

    Environment_tr.$inject = ['$resource'];

    function Environment_tr ($resource) {
        var resourceUrl =  'api/environment-trs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
